import Vue from 'vue'
import Vuex from 'vuex'
import i18n from "@/i18n";
import moment from 'moment';
import getSpecialization from "@/api/settings/getSpecialization";
import getDiagnosticTypes from "@/api/settings/getDiagnosticTypes";
import getDoctors from "@/api/settings/getDoctors";
import getDiagnostics from "@/api/settings/getDiagnostics";

Vue.use(Vuex)


const state = {
    doctors: [],
    settings: {},
    sliders:[],
    clinics:[],
    specializations:[],
    diagnosticTypes:[],
    diagnostics:[],
    language:process.env.VUE_APP_I18N_LOCALE,
}
const mutations = {
    SET_DOCTORS(state, payload) {
        state.doctors = payload;
    },
    SET_SETTINGS(state, payload) {
        state.settings = payload;
    },
    SET_SLIDERS(state, payload) {
        state.sliders = payload;
    },
    SET_CLINICS(state, payload) {
        state.clinics = payload;
    },
    SET_SPECIALIZATION(state, payload) {
        state.specializations = payload;
    },
    SET_DIAGNOSTICS(state, payload) {
        state.diagnostics = payload;
    },
    SET_DIAGNOSTIC_TYPES(state, payload) {
        state.diagnosticTypes = payload;
    },
    SET_LANGUAGE(state, payload) {
        state.language = payload
    }
}

const actions = {
    getDoctors({commit, dispatch}, payload) {
        commit('SET_DOCTORS', payload)
    },
    getSettings({commit, dispatch}, payload) {
        commit('SET_SETTINGS', payload)
    },
    getSliders({commit, dispatch}, payload) {
        commit('SET_SLIDERS', payload)
    },
    getClinics({commit, dispatch}, payload) {
        commit('SET_CLINICS', payload)
    },
    setLanguage({commit},{language,reload = false}){
        i18n.locale = language
        commit('SET_LANGUAGE',language)
        if(reload){
            window.location.reload()
        }

    },
    getSpecialization({commit},payload){
        return getSpecialization().then(response =>{
            commit('SET_SPECIALIZATION',response)
        })

    },
    getDiagnosticTypes({commit}){
        return getDiagnosticTypes().then(response =>{
            commit('SET_DIAGNOSTIC_TYPES',response)
        })
    },
    getDiagnostics({commit},payload){
        return getDiagnostics(payload).then(response =>{
            commit('SET_DIAGNOSTICS',response)
        })
    },
}

export default {
    state,
    mutations,
    actions
}